export const hasChildren = (children: any): boolean => {
	if (Array.isArray(children)) {
		return !!children.filter((c: any) => !!c).length;
	}
	else {
		return !!children;
	}
};